import React, { useState } from 'react';
import Slider from 'components/Slider';
import SelectPage from './SelectPage';
import PropTypes from 'prop-types';
import style from './style.scss'; //NOSONAR

const ShelfPaginator = (props) => {
    const totalPages = Math.ceil(props.pages);
    let buttons = [];
    const currentSlide = Math.floor((props.currentPage -1 ) / 6);
    const [showSelectPage, setShowSelectPage ] = useState(true)

    const clickButton = (index) => {
        props.setPage(index);
    }

    for (let i = 0; i < totalPages; i++) {
        buttons.push(i+1);
    }

    const verifyShowSelectPage = (value) => {
        setShowSelectPage(value)
    }

    return (
        <>
            <Slider arrows={true} className="paginator-slider" currentSlide={currentSlide} verifyShowSelectPage={verifyShowSelectPage}>
                {
                    buttons.map(index => {
                        return <button className={"page-number " + (index === props.currentPage ? 'active' : '')} onClick={() => clickButton(index)} key={index}>{index}</button>;
                    })
                }
            </Slider>
            {showSelectPage && <SelectPage buttons={buttons} totalPages={totalPages} currentPage={props.currentPage} clickButton={clickButton}/>}
        </>
    )

}

ShelfPaginator.propTypes = {
    pages: PropTypes.number,
    currentPage: PropTypes.number,
    setPage: PropTypes.func
};

export default ShelfPaginator;
